import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cn } from "../../Lib/Cn"

const SmallButton = React.forwardRef(({ className, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      type="button"
      className={cn(
        "px-2.5 py-1.5 text-xs font-medium rounded-md border border-zinc-200 bg-white hover:bg-zinc-50 text-zinc-700 transition-all duration-150 active:scale-95 flex items-center justify-center gap-1.5 whitespace-nowrap",
        className
      )}
      ref={ref}
      {...props}
    />
  )
})
SmallButton.displayName = "SmallButton"

export { SmallButton }
